/** Matches API <c>SlotFilterEnum</c> (Assigning Drivers tab). */
export enum SlotFilterEnum {
	All = 1,
	Active = 2,
	Inactive = 3
}
